// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"199":"465c2c64","220":"66d58678","716":"c694ead0"}[chunkId] + ".chunk.js";
};